import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect, useState } from "react";
import TransferMedRepSearch from "./TransferMedRepSearch";
import FromMedSearch from "./FromMedSearch";
import { Button, Spinner } from "react-bootstrap";
import DownloadTransferCustomer from "./DownloadTransferCustomer";
import { useAdminCaseManagement } from "./store";
import { useReps } from "modules/case_management/store";
import { isEmpty } from "lodash";
import FromMedTable from "./FromMedTable";
import ToMedTable from "./ToMedTable";
import { getMedRepLevel } from "modules/utilities/utility";
import { Popconfirm } from "antd";
import { useToast } from "modules/navbar/top/store/toasterStore";

function TransferCustomer() {
  const [selectedSearch, setSelectedSearch] = useState({});
  const [searchValue, setSearchValue] = useState(undefined);
  const [medRepSearchValue, setMedRepSearchValue] = useState(undefined);
  const [searchData, setSearchData] = useState([]);
  const [medRepSearchData, setMedRepSearchData] = useState([]);
  const [targetUserLevel, setTargetUserLevel] = useState(0);
  const [selectedUserID, setSelectedUserID] = useState("");
  const [engagementData, setEngagementData] = useState([]);
  const { medReps, fetchMedReps } = useReps();
  const [selectedFromMed, setSelectedFromMed] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [selectedEngagement, setSelectedEngagement] = useState([]);
  const [selectedMedRep, setSelectedMedRep] = useState([]);
  const [filterAgents, setFilterAgents] = useState([]);
  const [medRepName, setMedRepName] = useState("");
  const [summaryData, setSummaryData] = useState([]);
  const [engCallData, setEngCallData] = useState([]);
  const [message, setMessage] = useState([]);
  const {
    assignmentSumData,
    engagementCallData,
    assignmentLoading,
    transferLoading,
    engagementLoading,
    fetchAssignmentSummary,
    fetchEngagementCall,
    postTransferCustomer,
  } = useAdminCaseManagement();
  const { setToaster } = useToast();

  useEffect(() => {
    setSummaryData(assignmentSumData);
  }, [assignmentSumData, engagementCallData]);

  useEffect(() => {
    fetchMedReps();
  }, []);

  useEffect(() => {
    if (selectedFromMed?.user_id) {
      fetchAssignmentSummary(selectedFromMed?.user_id);
      fetchEngagementCall(selectedFromMed?.user_id);
    }
  }, [selectedFromMed]);

  useEffect(() => {
    if (message) {
      setTimeout(() => {
        setMessage("");
      }, 1500);
    }
  }, [message]);

  const handleSelectAgent = async () => {
    let filteredAgents;
    if (!isEmpty(medReps.userRole)) {
      filteredAgents = medReps.userRole.filter(
        (user) => user.user.level === targetUserLevel
      );
      setSearchData(filteredAgents);
    } else {
      setMessage("No data available");
      setSearchData([]);
    }
    let _filteredAgents = [];
    filteredAgents.map((item) => {
      _filteredAgents.push({
        first_name: item.user.first_name,
        id: item.user_id,
      });
    });

    let _agents = _filteredAgents.filter(
      (agent) => agent.id !== selectedUserID
    );

    _agents = _agents.map((agent, index) => {
      return Object.assign(agent, { key: index });
    });
    setFilterAgents(_agents);
  };

  useEffect(() => {
    if (!isEmpty(engagementCallData)) {
      let _customerData = [];
      engagementCallData["prescriptionCall"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      engagementCallData["engagementsCompleted"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      engagementCallData["week1"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      engagementCallData["week2"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      engagementCallData["week3"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      engagementCallData["week4"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      engagementCallData["week5"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      engagementCallData["week6"]?.map((call) => {
        _customerData.push({ case_id: call.id, email: call.user.email });
      });
      assignmentSumData["open_orders_data"]?.map((call) => {
        _customerData.push({
          case_id: call.case.id,
          email: call.case.user.email,
        });
      });
      setCustomerData(_customerData);
      let engagementArray = [];
      engagementArray.push(
        {
          key: 0,
          type: "tag",
          title: "Prescription Call",
          value: "Prescription Call",
          count: engagementCallData?.prescriptionCall?.length,
        },
        {
          key: 1,
          type: "tag",
          title: "Week 1",
          value: "Week #1",
          count: engagementCallData?.week1?.length,
        },
        {
          key: 2,
          type: "tag",
          title: "Week 2",
          value: "Week #2",
          count: engagementCallData?.week2?.length,
        },
        {
          key: 3,
          type: "tag",
          title: "Week 3",
          value: "Week #3",
          count: engagementCallData?.week3?.length,
        },
        {
          key: 4,
          type: "tag",
          title: "Week 4",
          value: "Week #4",
          count: engagementCallData?.week4?.length,
        },
        {
          key: 5,
          type: "tag",
          title: "Week 5",
          value: "Week #5",
          count: engagementCallData?.week5?.length,
        },
        {
          key: 6,
          type: "tag",
          title: "Week 6",
          value: "Week #6",
          count: engagementCallData?.week6?.length,
        },
        {
          key: 7,
          type: "active_orders",
          title: "Open Order",
          value: assignmentSumData.open_orders,
          count: assignmentSumData.open_orders,
        },
        {
          key: 8,
          type: "engagements_completed",
          title: "Engagements completed",
          value: engagementCallData?.engagementsCompleted,
          count: engagementCallData?.engagementsCompleted?.length,
        }
      );
      setSelectedEngagement(engagementArray);
      setEngagementData(engagementArray);
    }
  }, [assignmentSumData, engagementCallData]);

  const handleConfirm = async () => {
    const fromRepId = summaryData.rep_id;
    const transferList = summaryData.transferData;
    const targetList = selectedSearch.target;
    const toRepId = selectedSearch;

    if (isEmpty(transferList) || isEmpty(targetList)) {
      setMessage("Please choose one or more MedRep to transfer");
      return;
    }

    if (toRepId.target.includes(fromRepId)) {
      setMessage(`You can not transfer to the same med rep`);
      return;
    }
    let payload = {
      source: {
        repId: fromRepId,
        transferData: transferList,
      },
      target: targetList,
    };
    postTransferCustomer(payload, setToaster, handleClear);
  };

  const handleClear = () => {
    setTargetUserLevel(0);
    setSearchValue("");
    setMedRepSearchValue("");
    setSearchData("");
    setMedRepSearchData("");
    setSelectedSearch([]);
    setSummaryData([]);
    setCustomerData([]);
    setSelectedEngagement([]);
    setEngCallData([]);
    setMedRepName("");
  };

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex align-items-center">
            <div className="fs-2">Transfer Customer</div>
            {message ? (
              <div className="text-warning" style={{ marginLeft: "26%" }}>
                {message}
              </div>
            ) : null}
          </div>
        }
        component={
          <div style={{ minHeight: "60vh" }}>
            <div className="d-flex card p-3 flex-row justify-content-between gap-5">
              <div className="flex-1">
                <FromMedSearch
                  medRepSearchValue={medRepSearchValue}
                  setMedRepSearchValue={setMedRepSearchValue}
                  medRepSearchData={medRepSearchData}
                  setMedRepSearchData={setMedRepSearchData}
                  setTargetUserLevel={setTargetUserLevel}
                  setSelectedUserID={setSelectedUserID}
                  setSelectedFromMed={setSelectedFromMed}
                  medReps={medReps}
                  setMedRepName={setMedRepName}
                  setSummaryData={setSummaryData}
                  setEngCallData={setEngCallData}
                  setSelectedEngagement={setSelectedEngagement}
                  setCustomerData={setCustomerData}
                  setMessage={setMessage}
                />
              </div>
              <div className="flex-1">
                <TransferMedRepSearch
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                  searchData={searchData}
                  setSearchData={setSearchData}
                  selectedSearch={selectedSearch}
                  setSelectedSearch={setSelectedSearch}
                  targetUserLevel={targetUserLevel}
                  selectedUserID={selectedUserID}
                  engagementData={engagementData}
                  medReps={medReps}
                  selectedMedRep={selectedMedRep}
                  setSelectedMedRep={setSelectedMedRep}
                  filterAgents={filterAgents}
                  setFilterAgents={setFilterAgents}
                  setMessage={setMessage}
                />
              </div>
            </div>
            <div className="d-flex gap-5 justify-content-between mt-3">
              <div className="flex-1">
                <div className="d-flex flex-row p-3 justify-content-between card">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="fw-bold fs-1">Name</div>
                    <div className="">
                      {medRepName}(
                      {medRepName
                        ? getMedRepLevel[selectedFromMed?.user?.level]
                        : null}
                      )
                    </div>
                  </div>
                  <div>
                    <DownloadTransferCustomer
                      customerData={customerData}
                      setMessage={setMessage}
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1">
                <div className="card p-3">
                  <Button
                    disabled={targetUserLevel === 0}
                    className="btn btn-primary w-50"
                    onClick={() => {
                      handleSelectAgent();
                      setSelectedMedRep([]);
                    }}
                  >
                    Select All{" "}
                    {medRepName
                      ? getMedRepLevel[selectedFromMed?.user?.level]
                      : null}{" "}
                    Agents
                  </Button>
                </div>
              </div>
            </div>
            <div className="d-flex gap-5 flex-row justify-content-between mt-3">
              <div className="flex-1">
                <div className="card p-3">
                  <FromMedTable
                    engagementCallData={selectedEngagement}
                    isLoading={engagementLoading}
                    assignmentSumData={summaryData}
                    setSummaryData={setSummaryData}
                  />
                </div>
              </div>
              <div className="flex-1">
                <div className="card p-3">
                  <ToMedTable
                    selectedMedRep={selectedMedRep}
                    filterAgents={filterAgents}
                    setSelectedSearch={setSelectedSearch}
                  />
                </div>
              </div>
            </div>

            <div className="text-center mt-5">
              <Popconfirm
                disabled={
                  isEmpty(summaryData?.transferData) ||
                  isEmpty(selectedSearch?.target)
                }
                title="Are you sure you want to move this Med Rep?"
                placement="topRight"
                onConfirm={handleConfirm}
              >
                <Button
                  disabled={
                    isEmpty(summaryData?.transferData) ||
                    isEmpty(selectedSearch?.target)
                  }
                  type="primary"
                  danger
                  size="large"
                  loading={transferLoading}
                  style={{
                    fontSize: "1.5rem",
                    padding: ".2em 1em",
                    fontWeight: "bold",
                    height: "max-content",
                  }}
                >
                  {transferLoading ? (
                    <>
                      <Spinner animation="border" variant="warning" />
                      CONFIRM AND TRANSFER
                    </>
                  ) : (
                    "CONFIRM AND TRANSFER"
                  )}
                </Button>
              </Popconfirm>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default TransferCustomer;
